import {UploadFile} from "antd/lib/upload/interface";
import {
    RemoveSelectedFileAction,
    RemoveSelectedFilesAction,
    SetFinishedUploadsAction,
    SetSelectedFilesAction,
    SignFileResourceAction,
    SignJobFileAction,
    SignTaskFileAction,
} from "../../interfaces/store/actions/uploadFiles";
import {
    REMOVE_SELECTED_FILE,
    REMOVE_SELECTED_FILES,
    SET_FINISHED_UPLOADS,
    SET_SELECTED_FILES,
    SIGN_FILE_RESOURCE,
    SIGN_JOB_FILE,
    SIGN_TASK_FILE,
} from "./availableActions";
import {FinishedUploads, SelectedFiles} from "../../interfaces/store/reducers/uploadFilesState";
import {
    SignFileResourcePayload,
    SignTaskFilePayload,
    SignJobFilePayload,
} from "../../interfaces/store/actions/payload/uploadFiles";

export const setSelectedFiles = (payload: SelectedFiles): SetSelectedFilesAction => ({
    type: SET_SELECTED_FILES,
    payload,
});

export const removeSelectedFile = (payload: UploadFile): RemoveSelectedFileAction => ({
    type: REMOVE_SELECTED_FILE,
    payload,
});

export const setFinishedUploads = (payload: FinishedUploads): SetFinishedUploadsAction => ({
    type: SET_FINISHED_UPLOADS,
    payload,
});

export const removeSelectedFiles = (payload: UploadFile[]): RemoveSelectedFilesAction => ({
    type: REMOVE_SELECTED_FILES,
    payload,
});

export const signTaskFile = (payload: SignTaskFilePayload): SignTaskFileAction => ({
    type: SIGN_TASK_FILE,
    payload,
});

export const signJobFile = (payload: SignJobFilePayload): SignJobFileAction => ({
    type: SIGN_JOB_FILE,
    payload,
});

export const signFileResource = (payload: SignFileResourcePayload): SignFileResourceAction => ({
    type: SIGN_FILE_RESOURCE,
    payload,
});
